export default __webpack_public_path__ + "static/media/notfound.e3996102.svg";